import React, { useEffect, useState } from "react";
import goIcon from "../../../assets/images/icons/greaterthan.svg";
import IncidentReportingModal from "../IncidentReportingModal/IncidentReportingModal";
import "./IncidentCard.css";
import IncidentForm from "../IncidentForm/IncidentForm";
import { useLocation, useNavigate } from "react-router-dom";
import { flushSync } from "react-dom";

const IncidentCard = ({ image, title, types, incidentGroupId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const incidentRelation = queryParams.get("incidentRelation");
  const [showTypes, setShowTypes] = useState(false);
  const [showSubTypes, setShowSubTypes] = useState(false);
  const [subTypes, setSubTypes] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [activeGroup, setActiveGroup] = useState(false);
  const [activeType, setActiveType] = useState(0);
  const [activeSubType, setActiveSubType] = useState(0);
  const [showConformationModal, setShowConformationModal] = useState(false);
  const [typeSelection, setTypeSelection] = useState({
    typeId: 0,
    subTypeId: 0,
  });
  const [key, setKey] = useState(1);

  const handleShowTypes = () => {
    setShowTypes((prev) => !prev);
    setActiveGroup((prev) => !prev);
    if (showTypes) {
      setSubTypes([]);
      setShowSubTypes(false);
      setActiveGroup(false);
      setActiveType(0);
      setActiveSubType(0);
    }
  };

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const handleShowSubTypes = (subTypes, typeId) => {
    setSubTypes(subTypes);
    setActiveType(typeId);
    setShowSubTypes(true);
  };

  const handleIncidentSelection = (subTypeId) => {
    setActiveSubType(subTypeId);
    setTypeSelection({
      typeId: activeType,
      subTypeId,
    });
    toggleModal();
  };

  const handleCreateLinkedIncident = () => {
    flushSync(() => {
      toggleModal();
      setShowConformationModal(false);
      if (key === 1) {
        setKey(2);
      } else {
        setKey(1);
      }
    });
    navigate(`/incidents/new?incidentRelation=linked`);
  };

  const handleNo = () => {
    toggleModal();
    setShowConformationModal(false);
    localStorage.removeItem("fromIncidentId");
    navigate("/incidents");
  };

  const handleModalClose = () => {
    if (showConformationModal) {
      localStorage.removeItem("fromIncidentId");
      navigate("/incidents/new");
    }
    toggleModal();
    setShowConformationModal(false);
  };

  const resetMenu = () => {
    setShowTypes(false);
    setActiveGroup(false);
    if (showTypes) {
      setSubTypes([]);
      setShowSubTypes(false);
      setActiveGroup(false);
      setActiveType(0);
      setActiveSubType(0);
    }
  };

  useEffect(() => {
    if (incidentRelation === "linked" || incidentRelation === "related") {
      resetMenu();
    }
  }, [location]);

  return (
    <>
      <div className="col-md-3">
        <div
          className={`incident-card ${activeGroup ? "active" : ""}`}
          role="button"
          onClick={handleShowTypes}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleShowTypes();
            }
          }}
          aria-expanded={showTypes}
          aria-controls="types-list"
          tabIndex={incidentGroupId}
        >
          <div className="card-header incident-card-header text-center">
            <div className="card-image">
              <img
                src={image}
                height={72}
                width={72}
                className="rounded-border"
                alt={title}
              />
            </div>
            <div className="text-center">
              {title}
              <img
                src={goIcon}
                width={24}
                alt={`Select incident group ${title}`}
              />
            </div>
          </div>
        </div>
      </div>
      {showTypes && types.length > 0 ? (
        <div className="col-md-3">
          <div className="card">
            <div className="card-body incident-card-body">
              <ul className="list-group list-group-flush incident-list">
                {types.map((type) => (
                  <li
                    key={type.id}
                    className={`list-group-item incident-list-item ${
                      activeType === type.id ? "active" : ""
                    }`}
                    title={type?.note || type?.description}
                    onClick={() => handleShowSubTypes(type?.subTypes, type.id)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleShowSubTypes(type?.subTypes, type.id);
                      }
                    }}
                    tabIndex={type.id}
                    aria-expanded={showSubTypes && activeType === type.id}
                    aria-controls={`subtypes-list-${type.id}`}
                  >
                    <span>{type.description}</span>
                    <img
                      src={goIcon}
                      width={24}
                      alt={`Select incident sub type ${type.description}`}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {showSubTypes && subTypes?.length > 0 ? (
        <div className="col-md-3">
          <div className="card">
            <div className="card-body incident-card-body">
              <ul className="list-group list-group-flush incident-list">
                {subTypes?.map((subType) => (
                  <li
                    role="button"
                    key={subType.id}
                    title={subType?.note || subType?.description}
                    className={`list-group-item incident-list-item ${
                      activeSubType === subType.id ? "active" : ""
                    }`}
                    onClick={() => handleIncidentSelection(subType.id)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleIncidentSelection(subType.id);
                      }
                    }}
                    tabIndex={subType.id}
                    aria-expanded={showSubTypes && activeType === subType.id}
                    aria-controls={`subtypes-list-${subType.id}`}
                  >
                    <span>{subType.description}</span>
                    <img src={goIcon} width={24} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <IncidentReportingModal isOpen={modalIsOpen} toggle={handleModalClose}>
        {showConformationModal ? (
          <div>
            <h4 className="mb-5 text-center">
              Would you like to create a linked incident ?
            </h4>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-green me-3 px-5"
                onClick={handleCreateLinkedIncident}
              >
                Yes
              </button>
              <button className="btn btn-green-outline px-5" onClick={handleNo}>
                No
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
        <IncidentForm
          key={key}
          defaultValues={{
            IncidentGroup: incidentGroupId,
            IncidentType: typeSelection.typeId,
            IncidentSubType: typeSelection.subTypeId,
          }}
          showConformationModal={setShowConformationModal}
          selectedTypes={typeSelection}
          toggleModal={toggleModal}
        />
      </IncidentReportingModal>
    </>
  );
};

export default IncidentCard;
